<template>
  <div>
    <div class="flex items-center justify-between mb-2">
      <div class="flex items-center gap-2">
        <div class="font-medium text-lg" v-html="heading" />
      </div>
      <!-- <div class="flex items-center gap-2">
        <button class="flex items-center gap-2" @click="showAll = !showAll">
          <span class="text-xs" v-html="$t('fat.filters.all')" />
          <AtomIcon :name="showAll ? 'circle-minus' : 'circle-plus'" class="text-sm" />
        </button>
      </div> -->
    </div>
    <div class="tags" v-auto-animate>
      <div v-for="tag in tags" :key="tag.id">
        <button class="tags__button" :class="{ 'active': fat.tagIds.includes(tag.id) }" @click="toggleTag(tag.id)">
          <span v-html="tag.label" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  heading: String,
  groupId: Number,
})

const app = useAppStore()
const fat = useFatStore()
const showAll = ref(true)

// Find the correct tag group
const allTags = computed(() => app.tags?.filter(tag => tag.groupId === props.groupId))

// Filter tags based on featured, active and show all
const tags = computed(() => allTags.value
  ?.map(tag => ({
    ...tag,
    active: fat.tagIds.includes(tag.id)
  }))
  ?.filter(tag => showAll.value ? true : (tag.isFeatured || tag.active)))

// Toggle tag
const toggleTag = (tagId) => {
  fat.tagIds.includes(tagId) 
    ? fat.tagIds = fat.tagIds.filter(id => id !== tagId)
    : fat.tagIds.push(parseInt(tagId))

  useUpdateQuery({ tagIds: fat.tagIds?.join(',') || undefined })
}
</script>

<style lang="scss" scoped>
.tags {
  @apply text-sm;
  @apply flex gap-2 flex-wrap;
  
  &__button {
    @apply px-2 py-1;
    @apply bg-mist text-black/80 border border-mist rounded duration-300;

    &.active {
      @apply text-ocean border-ocean/40 bg-sky font-normal;
    }
  }
}
</style>